define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var EPSILON = Math.pow(2, -52);
    function fixZero(x) {
        return x === 0 ? 0 : x;
    }
    function intersects(src, target) {
        var a1 = src.a, b1 = src.b, c1 = src.c;
        var a2 = target.a, b2 = target.b, c2 = target.c;
        var xfactor = a1 * b2 - a2 * b1;
        var xnumerator = c2 * b1 - c1 * b2;
        var yfactor = b1 * a2 - b2 * a1;
        var ynumerator = c2 * a1 - c1 * a2;
        var x = fixZero(xfactor === 0 ? undefined : xnumerator / xfactor);
        var y = fixZero(yfactor === 0 ? undefined : ynumerator / yfactor);
        return { x: x, y: y };
    }
    exports.intersects = intersects;
    function shift(src, offset) {
        var a = src.a, b = src.b, c = src.c;
        var dx = offset.x, dy = offset.y;
        return { a: a, b: b, c: c - a * dx - b * dy };
    }
    exports.shift = shift;
    function getLine(from, to) {
        var dx = to.x - from.x;
        var dy = to.y - from.y;
        if (dx === 0 && dy === 0) {
            return undefined;
        }
        if (dx === 0) {
            return {
                a: 1,
                b: 0,
                c: from.x === 0 ? 0 : -from.x
            };
        }
        if (dy === 0) {
            return {
                a: 0,
                b: 1,
                c: from.y === 0 ? 0 : -from.y
            };
        }
        return {
            a: 1,
            b: -dx / dy,
            c: -from.x + dx / dy * from.y
        };
    }
    exports.getLine = getLine;
    function isIncident(point, line) {
        var x = point.x, y = point.y;
        var a = line.a, b = line.b, c = line.c;
        console.log("delta = " + (a * x + b * y + c));
        return Math.abs(a * x + b * y + c) <= 4 * EPSILON;
    }
    exports.isIncident = isIncident;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/algebra.js
// module id = 41
// module chunks = 0